<script>
import styleHOCFactory from './utils';
export default styleHOCFactory('clear');
</script>

<style module>
@import 'styles/variables.css';

._clear-style {
  composes: relative from global;
  fill: var(--green);
  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    z-index: -1;
    pointer-events: none;
    background: var(--green);
    transition: width .25s ease-in-out, color .25s ease-in-out, fill .25s ease-in-out;
  }
  &:hover:before, &:global(.-hover:before), &:global(.router-link-exact-active:before) {
    width: 100%;
  }
  &:hover {
    fill: black;
    color: black;
  }
  & :global(.icon) {
    width: 2.1rem;
  }
}
</style>
